<template>
  <div class="footer">
    <div class="top_content">
      <img class="logo_img" src="../../assets/pc/pcFooter/logo.png" alt="" />
      <div class="contact">
        <div class="title">联系我们</div>
        <div class="content">
          公司地址：湖南省长沙市岳麓区环湖路1177号金茂广场南塔 湘江集团大厦19层
        </div>
        <!-- <div class="content">联系方式：guohao@hskgoo.com</div> -->
        <div class="content">联系方式：400-862-8806</div>
      </div>
      <div class="cooperation">
        <div class="title">更多合作</div>
        <div class="content click code">
          商务合作
          <img class="code_img" src="../../assets/pc/pcFooter/code.png" alt="" />
        </div>
        <div
          class="content click"
          @click="toPage('https://mp.weixin.qq.com/s/YgpJofxRwCwEAD5L7W_XcA')"
        >
          加入我们
        </div>
      </div>
    </div>
    <div class="bottom_content_box">
      <div class="bottom_content">
        <div class="bottom_content_title">更多服务</div>
        <div style="display: table; width: calc(1200px - 34px - 144px)">
          <div
            class="bottom_content_item"
            v-for="(item, i) in juquAppList"
            v-show="item.name"
            :key="i"
            @click="toPage(item.website || item.download)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div>
        <!-- <div class="img_list flexVerticalCenter"> -->
        <div class="img_list">
          <img
            class="img"
            v-for="(item, i) in imgList"
            :key="i"
            :src="item.img"
            alt=""
            @click="toPage(item.url)"
          />
        </div>
        <div class="des">
          <div class="content">
            Copyright © 2017-{{ new Date().getFullYear() }} 聚趣教育科技有限公司版权所有
          </div>
          <div class="content click" @click="toPage('http://beian.miit.gov.cn')">
            备案号：湘ICP备2021002148号-1
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        /*{
					img: require('@/assets/pc/pcFooter/bilibili.png'),
					url: 'https://space.bilibili.com/517809714'
				},*/
        {
          img: require("@/assets/pc/pcFooter/taobao.png"),
          url: "https://juquedu.taobao.com/",
        },
        // {
        // 	img: require('@/assets/pc/pcFooter/weidian.png'),
        // 	url: '',
        // },
      ],
      juquAppList: [
        {
          name: "聚趣日语",
          download: "https://api.juquedu.com/website/index.html",
          sort: 10,
          sort2: 10,
          appName: "日语GO",
          img: require("@/assets/pc/introduce/ri.png"),
        },
        {
          name: "聚趣德语",
          download: "https://german.juquedu.com/website/index.html",
          sort: 20,
          sort2: 20,
          appName: "德语GO",
          img: require("@/assets/pc/introduce/de.png"),
        },
        {
          name: "聚趣法语",
          download: "https://fr.juquedu.com/website/index.html",
          sort: 30,
          sort2: 30,
          appName: "法语GO",
          img: require("@/assets/pc/introduce/fa.png"),
        },
        {
          name: "聚趣韩语",
          download: "https://korean.juquedu.com/website/index.html",
          sort: 40,
          sort2: 40,
          appName: "韩语GO",
          img: require("@/assets/pc/introduce/han.png"),
        },
        {
          name: "聚趣西语",
          download: "https://spain.juquedu.com/website/index.html",
          sort: 50,
          sort2: 50,
          appName: "西语GO",
          img: require("@/assets/pc/introduce/xi.png"),
        },
        {
          name: "聚趣IELTS",
          download: "https://ielts.juquedu.com/website/index.html",
          sort: 60,
          sort2: 60,
          appName: "雅思GO",
          img: require("@/assets/pc/introduce/yasi.png"),
        },
        {
          name: "",
          download: "https://germanword.juquedu.com/website/index.html",
          sort: 70,
          sort2: 70,
          appName: "德语背单词",
          img: require("@/assets/pc/introduce/debei.png"),
        },
        {
          name: "",
          download: "https://hw.juquedu.com/website/",
          sort: 80,
          sort2: 80,
          appName: "LingoMaster",
          img: require("@/assets/pc/introduce/lingo.png"),
        },
        {
          name: "聚趣留学",
          website: "https://www.liuxuefun.com/",
          download: "https://lxgowap.juquedu.com/goStudyAbroad/",
          sort: 90,
          sort2: 1,
          appName: "趣留学GO",
          img: require("@/assets/pc/introduce/lx.png"),
        },
      ],
    };
  },
  created() {
    localStorage.setItem("juquAppList", JSON.stringify(this.juquAppList));
    this.juquAppList = this.juquAppList.sort((a, b) => {
      // 按照age字段升序排序
      return a.sort2 - b.sort2;
    });
  },
  methods: {
    toPage(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  // height: 358px;
  background: #222326;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #afa6a6;
  font-size: 14px;

  min-width: 1200px;
  color: #ffffff;
  padding: 54px 0 32px;
  .top_content {
    min-width: 1200px;
    display: flex;
    padding-bottom: 54px;
    border-bottom: 1px #3f4148 solid;
    .contact {
      margin-left: 84px;
    }
    .cooperation {
      margin-left: 124px;
    }
    .logo_img {
      width: 246px;
      height: 49px;
      margin: 46px 0 0 34px;
    }
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .content {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 8px;
    color: #b7b8c2;
    a {
      color: #b7b8c2;
    }
  }
  .click {
    cursor: pointer;
  }
  .click:hover {
    color: #ffffff;
  }
  .code {
    position: relative;
    .code_img {
      width: 121px;
      height: 121px;
      display: none;
      position: absolute;
      top: 0;
      left: 86px;
    }
  }
  .code:hover {
    .code_img {
      display: block;
    }
  }
  .bottom_content_box {
    min-width: 1200px;
    margin-top: 20px;
    > div {
      display: flex;
      margin-left: 34px;
    }
    .bottom_content {
      font-size: 16px;
      padding-bottom: 30px;
      .bottom_content_title {
        font-weight: 400;
        color: #b7b8c2;
        margin-right: 80px;
      }
      .bottom_content_item {
        font-weight: bold;
        color: #ffffff;
        margin: 0 40px 10px 0;
        cursor: pointer;
        float: left;
      }
      .bottom_content_item:last-child {
        padding-right: 0;
      }
      .bottom_content_item:hover {
        color: #4d4dd9;
      }
    }
    .img_list {
      width: 246px;
      margin-right: 84px;
      display: flex;
      .img {
        width: 50px;
        height: 50px;
        margin-right: 38px;
        cursor: pointer;
      }
      .img:first-child {
        // margin-left: 34px;
        // margin-right: 83px;
      }
      // .img:nth-child(3) {
      // 	width: 70px;
      // 	margin-right: 83px;
      // }
    }
  }
}
</style>
